import request from '@/service/request'

/* 床位清空记录 page
 */
export const pageBedClearRecordApi = (params) => {
  return request.post('/dormitory/clearDormitoryBedRecord/page', params)
}
